document.addEventListener('DOMContentLoaded',function(){
  const toggle=document.querySelector('[data-menu-toggle]');
  const nav=document.querySelector('[data-main-nav]');
  if(toggle&&nav){toggle.addEventListener('click',()=>{const open=nav.classList.toggle('is-open');toggle.setAttribute('aria-expanded',String(open));});}
  document.querySelectorAll('[data-quantity-minus],[data-quantity-plus]').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const wrap=btn.closest('.quantity-control'); const input=wrap&&wrap.querySelector('input'); if(!input)return;
      let n=parseInt(input.value||'1',10); const min=parseInt(input.min||'1',10);
      n=btn.hasAttribute('data-quantity-plus')?n+1:Math.max(min,n-1); input.value=n; input.dispatchEvent(new Event('change',{bubbles:true}));
    });
  });
  const variant=document.getElementById('VariantSelect');
  if(variant){variant.addEventListener('change',()=>{const url=new URL(window.location.href);url.searchParams.set('variant',variant.value);history.replaceState({},'',url);});}
});
